/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RouteData model module.
 * @module model/RouteData
 * @version V1
 */
class RouteData {
    /**
     * Constructs a new <code>RouteData</code>.
     * @alias module:model/RouteData
     */
    constructor() { 
        
        RouteData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RouteData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RouteData} obj Optional instance to populate.
     * @return {module:model/RouteData} The populated <code>RouteData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RouteData();

            if (data.hasOwnProperty('dataTokens')) {
                obj['dataTokens'] = ApiClient.convertToType(data['dataTokens'], {'String': Object});
            }
            if (data.hasOwnProperty('routers')) {
                obj['routers'] = ApiClient.convertToType(data['routers'], [Object]);
            }
            if (data.hasOwnProperty('values')) {
                obj['values'] = ApiClient.convertToType(data['values'], {'String': Object});
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>RouteData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RouteData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['routers'])) {
            throw new Error("Expected the field `routers` to be an array in the JSON data but got " + data['routers']);
        }

        return true;
    }


}



/**
 * @member {Object.<String, Object>} dataTokens
 */
RouteData.prototype['dataTokens'] = undefined;

/**
 * @member {Array.<Object>} routers
 */
RouteData.prototype['routers'] = undefined;

/**
 * @member {Object.<String, Object>} values
 */
RouteData.prototype['values'] = undefined;






export default RouteData;

